export default __webpack_public_path__ + "static/media/loginLogo.98eb5844.svg";